export default __webpack_public_path__ + "static/Mcglynn-f7ba7068adac99827b71d5509125d7d5.jpg";